module.exports = __webpack_public_path__ + "static/media/uploadImg.83c59c46.png";